import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Waitlist from './components/Waitlist';
import SimpleFooter from './components/SimpleFooter';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={
            <div className="App">
              <Helmet>
                <title>Humaniti.ai - Intelligence designed around human connection</title>
                <meta name="description" content="Experience the future of business-customer interactions with Humaniti.ai. Join our early access program to experience AI that understands and enhances human interaction." />
                <link rel="canonical" href="https://humaniti.ai" />
              </Helmet>
              <Header />
              <main>
                <Hero />
                <Features />
                <About />
                <Waitlist />
              </main>
              <SimpleFooter />
            </div>
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
